import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=f9a746c8&scoped=true&"
import script from "./ContentLayout.vue?vue&type=script&lang=js&"
export * from "./ContentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a746c8",
  null
  
)

export default component.exports